import React from "react";
import { Button, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { caseConstants } from "@_constants/case.constants";
import { emailConstants } from "@_constants/email_flows.constants";
import styles from "../MailPopup.module.css";

/**
 * Presentational footer with the Close / Preview / send actions and the
 * in-flight spinner. The send button is disabled until the mail is valid
 * (and, for letters, previewed). Pure move of the button row that
 * previously lived inline in MailPopup; the resolved send handler is
 * passed in by the parent.
 */
function PopupFooter({
  loading,
  dataType,
  caseState,
  sendEmailTag,
  missingPlaceholder,
  inputsTo,
  inputsSubject,
  didPreviewLetter,
  hasUnreviewedChanges,
  onClose,
  onPreview,
  onSend,
}) {
  const isLetter = dataType === emailConstants.TEMPLATE_TYPE_LETTER;
  const previewDisabled = missingPlaceholder || loading || !inputsSubject;
  const sendDisabled =
    !sendEmailTag ||
    missingPlaceholder ||
    loading ||
    !inputsTo ||
    !inputsSubject ||
    (isLetter && (!didPreviewLetter || hasUnreviewedChanges));

  const getDisabledTooltip = () => {
    if (!inputsSubject) return "Please fill in the subject.";
    if (missingPlaceholder) return "Please fill in all placeholders.";
    if (isLetter && !didPreviewLetter)
      return "Please preview the letter before sending it.";
    if (isLetter && hasUnreviewedChanges)
      return "Please preview the letter again after making changes.";
    if (!sendEmailTag)
      return "Your email setup is incomplete or invalid. Please check it under Email Setup.";
    return "";
  };

  return (
    <div className={styles.btn_container}>
      <Button className="btn_cancel" onClick={onClose}>
        Close
      </Button>
      {!loading && isLetter && (
        <Tooltip
          title={previewDisabled ? getDisabledTooltip() : ""}
          placement="top"
        >
          <span>
            <Button
              className={`btn_confirm ${previewDisabled ? "btn_disabled" : ""}`}
              onClick={onPreview}
              disabled={previewDisabled}
            >
              Preview
            </Button>
          </span>
        </Tooltip>
      )}
      {loading && (
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      )}

      {!loading && caseState !== caseConstants.CASE_STATE_STANDBY && (
        <Tooltip
          title={sendDisabled ? getDisabledTooltip() : ""}
          placement="top"
        >
          <span>
            <Button
              className={`btn_confirm ${sendDisabled ? "btn_disabled" : ""}`}
              onClick={onSend}
              disabled={sendDisabled}
            >
              send
            </Button>
          </span>
        </Tooltip>
      )}
    </div>
  );
}

export default PopupFooter;
